var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('Alert'),_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"8","lg":"6"}},[_c('XeroAuthCallback')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }